const key = '__longswap_lang'

export const getLang = () => {
  const local = localStorage.getItem(key)
  return local ? local : 'zh_cn'
}

export const setLang = (val) => {
  localStorage.setItem(key, val)
}